export { default } from './ListOneTicketDetails';
